import styled from '@emotion/styled'

import { colors, typography } from '../theme'

const Text = styled.span<{ color?: keyof typeof colors; typography?: keyof typeof typography }>`
  ${({ theme, color }) => (color ? `color: ${theme.colors[color]};` : '')}
  ${({ theme, typography }) => (typography ? theme.typography[typography] : '')}
`

export default Text
